import { type Context, createContext } from 'react';
import { createMutation, createQuery } from 'react-query-kit';
import type { Api } from './Api';
import { ApiError } from './ApiError';

const mutate = <Response, Request>() =>
  createMutation<Response, Request, ApiError>({
    mutationFn: () => Promise.reject(new ApiError(new Response())),
  });

const queryFn = () => Promise.reject(new ApiError(new Response()));
const query = <Response, Request>(primaryKey: string) =>
  createQuery<Response, Request, ApiError>({
    queryKey: [primaryKey],
    fetcher: queryFn,
  });

const DUMMY_API: Api = {
  feature: {
    categories: query('feature/categories'),
    create: mutate(),
    id: () => ({
      delete: mutate(),
      get: query('feature/get'),
      patch: mutate(),
    }),
    writeDescription: query('feature/write-description'),
  },
  property: {
    id: (id: number) => ({
      features: query(`property/${id.toString()}/features`),
      get: query(`property/${id.toString()}/get`),
    }),
  },
  // user: {
  //   currentUser: query('user/current-user'),
  // },
};

export const ApiContext: Context<Api> = createContext(DUMMY_API);
